import React from "react";
import { usePopupContext } from "../../context-api/popup-context";
import background from "../../Assets/Images/hero/hero-bg.png";
import { IoCloseSharp } from "react-icons/io5";

const DiscountCode = ({ setIsModalOpen }) => {
  const { userEmail, setUserEmail, setCatchUser, setUserClosedModal } =
    usePopupContext();

  const closeModal = () => {
    setUserClosedModal(true);
    setIsModalOpen(false);
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setUserEmail(email);
  };

  const onSubmitEmail = (e) => {
    e.preventDefault();
    //Push email to mailchimp api route
    setCatchUser(true);
    setUserEmail("");
    setTimeout(() => {
      setIsModalOpen(false);
    }, 3000);
  };
  return (
    <div className="discount-code_modal">
      <button className="home-modal-close" onClick={closeModal}>
        <IoCloseSharp />
      </button>
      <div className="discount-code_content-wrapper">
        <h1 class="title">JANUARY SPEACIAL OFFER!!!</h1>
        <p class="save-quote-subtitle">
          Up To <b className="discount-code_bold">30% Discount Code</b> For
          Boiler & Pumbing Repairs, Boiler Servicing & New Boiler Installations
        </p>
        <form className="discount-code_form">
          <div className="discount-code_form--controller">
            <input
              className="discount-code_form--input"
              type="text"
              placeholder="Enter Your Email Address"
              value={userEmail}
              onChange={onChangeEmail}
            />
          </div>
          <button className="discount-code_form--btn" onClick={onSubmitEmail}>
            Get Discount Code
          </button>
        </form>
      </div>
      <div className="discount-code_img-wrapper">
        <img className="discount-code_bg" src={background} alt="" />
      </div>
    </div>
  );
};

export default DiscountCode;
